import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { provide, ref, computed, ComputedRef } from "vue";

export type ProvidePreview = ComputedRef<boolean>;


export default /*#__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props) {

const previewCode = ref(true);

provide<ProvidePreview>(
  "preview",
  computed(() => previewCode.value)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", {
      toggle: 
        () => {
          previewCode.value = !previewCode.value;
        }
      
    })
  ]))
}
}

})